import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { EMBEDFUL_FEATURES, EMBEDFUL_BENEFITS } from "../../../constants";
import { SITE_URL } from "../../common/SEO";

class Features extends Component {
  buildHowToSchema() {
    return {
      "@context": "https://schema.org",
      "@type": "HowTo",
      name: "How Embedful Works",
      description:
        "From raw data to a secure, customer-facing dashboard, with no analytics infrastructure to build or maintain.",
      step: EMBEDFUL_FEATURES.map(({ step, description }) => ({
        "@type": "HowToStep",
        name: step,
        text: description,
      })),
      about: {
        "@type": "SoftwareApplication",
        name: "Embedful",
        url: `${SITE_URL}/embedful`,
      },
    };
  }

  renderFeatures() {
    let features = EMBEDFUL_FEATURES.map(({ step, icon, description }, index) => {
      return (
        <div
          key={`ef ${step}`}
          className="col-12 col-md-4 embedful-feature anim_piece"
        >
          <div className="embedful-feature-top">
            <span className="embedful-feature-index">{`0${index + 1}`}</span>
            <span className={`embedful-feature-icon fa ${icon}`}></span>
          </div>
          <h5 className="embedful-feature-title">{step}</h5>
          <p className="embedful-feature-desc">{description}</p>
        </div>
      );
    });

    return features;
  }

  renderBenefits() {
    let benefits = EMBEDFUL_BENEFITS.map(({ value, label }) => {
      return (
        <div key={`benefit ${label}`} className="embedful-benefit">
          <span className="embedful-benefit-value">{value}</span>
          <span className="embedful-benefit-label">{label}</span>
        </div>
      );
    });

    return benefits;
  }

  render() {
    return (
      <section id="embedful-features">
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(this.buildHowToSchema())}
          </script>
        </Helmet>
        <div className="container">
          <div className="row">
            <div className="col text-center">
              <h2 className="anim_piece">How Embedful Works</h2>
              <p className="embedful-features-subhead anim_piece">
                From raw data to a secure, customer-facing dashboard, with no
                analytics infrastructure to build or maintain.
              </p>
            </div>
          </div>

          <div className="row embedful-feature-row">{this.renderFeatures()}</div>

          <div className="row">
            <div className="col">
              <div className="embedful-benefits-row anim_piece">
                {this.renderBenefits()}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Features;
